import { render, staticRenderFns } from "./AskPartsForm.vue?vue&type=template&id=0a71d13e&scoped=true&lang=pug"
import script from "./AskPartsForm.vue?vue&type=script&lang=js"
export * from "./AskPartsForm.vue?vue&type=script&lang=js"
import style0 from "./AskPartsForm.vue?vue&type=style&index=0&id=0a71d13e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a71d13e",
  null
  
)

export default component.exports